import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import routes from './routes'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// import { accountService } from '@/services/account'

Vue.config.productionTip = false

Vue.use(VueRouter)

// configure router
export const router = new VueRouter({
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  },
})

const facebookAppId = "815837322947194";
/*
export function initFacebookSdk() {
    return new Promise(resolve => {
        // wait for facebook sdk to initialize before starting the vue app
        window.fbAsyncInit = function () {
            FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v8.0'
            });

            console.log('FB...')

            // auto authenticate with the api if already logged in with facebook
            FB.getLoginStatus(({ authResponse }) => {
                if (authResponse) {
                    accountService.apiAuthenticate(authResponse.accessToken).then(resolve);
                } else {
                    resolve();
                }
            });
        };

        // load facebook sdk script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));    
    });
}

initFacebookSdk().then(startApp);
*/

function startApp() {
  new Vue({
    render: h => h(App),
    router: router,
    vuetify: vuetify,
    store: store
  }).$mount('#app')
}

startApp()